"use client";

import { useEffect, useState } from "react";

/**
 * This component detects when the mobile keyboard is open or closed.
 * It sets a CSS custom property that can be used by other components.
 * This allows navigation components to remain server components.
 */
export default function KeyboardDetector() {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const currentHeight = window.visualViewport?.height || window.innerHeight;
      const screenHeight = window.screen.height;

      // If viewport is significantly smaller than screen, keyboard is likely open
      const keyboardOpen = currentHeight < screenHeight * 0.75;
      setIsKeyboardOpen(keyboardOpen);
    };

    // Listen to visualViewport changes (primary method for keyboard detection)
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleResize);
    }

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  useEffect(() => {
    // Set CSS custom property on document root
    // Other components can use this to determine if keyboard is open
    document.documentElement.style.setProperty("--keyboard-open", isKeyboardOpen ? "1" : "0");
  }, [isKeyboardOpen]);

  // This component renders nothing - it just manages the CSS custom property
  return null;
}
